<template>
  <div>
    <OneGoal :showGoal="showGoal" @close="showGoal = false"></OneGoal>
    <transition name="fade">
      <div
        v-show="loading"
        class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
      >
        <Loader class="center-h-v" />
      </div>
    </transition>

    <div class="m-2" style="border-radius: 0.5rem;">
      <el-collapse
        accordion
        v-model="activeItem"
        @change="handleItemClick"
        v-for="(reviews, type) in reviewGroups"
        :key="type"
        :class="type"
      >
        <el-collapse-item
          :name="review.ObjectiveId"
          v-for="review in reviews"
          :key="review.ObjectiveId"
          class="mt-3"
        >
          <template slot="title">
            <div class="complete-circle"></div>
            <h1 class="font-bolder">{{ review.GoalName }}</h1>
          </template>
          <!-- {{ reviews }} -->
          <main class="bg-gray-200 py-2 px-4 w-full" v-if="infoByReviewId[review.ObjectiveId]">
            <section class="w-full my-2">
              <div class="flex w-full items-center gap-4">
                <div class="flex items-center gap-2">
                  <h1 class="font-bold text-lg">Goal Name:</h1>
                  <small class="text-sm">{{ review.GoalName }}</small>
                </div>

                <div class="flex items-center gap-2">
                  <h1 class="font-bold text-lg">Goal Measure:</h1>
                  <small class="text-sm">{{ review.GoalMeasure }}</small>
                </div>
                <div class="flex items-center gap-2">
                  <h1 class="font-bold text-lg">Goal Weight:</h1>

                  <small class="text-sm"
                    >{{ review.Weight ? review.Weight : 0 }}%
                  </small>
                </div>
                <div class="flex items-center gap-2">
                  <h1 class="font-bold text-lg">Target:</h1>
                  <small class="text-sm">{{ review.Target }}</small>
                </div>
              </div>
            </section>
            <article class="my-2">
              <header>
                <h1 class="font-bold text-lg">Description</h1>
              </header>
              <div>
                <p v-if="!loading">{{ review.Description }}</p>
                <el-skeleton
                  :rows="3"
                  animated
                  v-if="loading"
                  :loading="loading"
                  variant="text"
                  style="width: 80%"
                />
              </div>
            </article>
            <section
              class="bg-white w-full rounded-lg mb-4"
              v-for="assessment in assessments"
              :key="assessment.name"
            >
              <header
                class="w-full border-b-1.5 flex justify-between items-center"
              >
                <h1 class="text-lg font-bold p-2">{{ assessment.name }}</h1>
                <div class="flex gap-2">
                  <p
                    :style="{
                      'background-color':
                        info.ObjectiveStatus === 'Draft'
                          ? '#87CEEB'
                          : '#4CAF50',
                      color: '#fff',
                      padding: '1px 8px',
                      'border-radius': '5px',
                    }"
                    class="mr-2"
                  >
                    {{ info.ObjectiveStatus }}
                  </p>
                </div>
              </header>
              <main class="flex flex-col gap-2">
                <section class="flex gap-2">
                  <div class="flex w-full items-center p-2">
                    <div class="flex flex-col w-full">
                      <h1 class="font-bold text-lg">Achieved Target</h1>

                      <el-skeleton
                        :rows="1"
                        animated
                        v-if="loading"
                        :loading="loading"
                        variant="text"
                        style="width: 80%"
                      />
                      <input
                          v-if="!loading && !assessment.isDisabled"
                          :type=review.GoalMeasure
                          class="bg-gray-200"
                          required
                          :disabled="!assessment.isDisabled"
                          :value="info.AchievedTarget"
                      />
                      <input
                          v-if="!loading && assessment.isDisabled"
                          :type=review.GoalMeasure
                          :value="infoByReviewId[review.ObjectiveId].myReview[0].AchievedTarget"
                          placeholder="6 Trainings"
                          class="bg-gray-200"
                          required
                          :disabled="assessment.isDisabled"
                      />
                    </div>
                  </div>
                  <!-- {{ info }} -->
                  <div class="flex w-full items-center p-2">
                    <div class="flex flex-col w-full">
                      <h1 class="font-bold text-lg">Attachment</h1>
                      <el-skeleton
                        :rows="1"
                        animated
                        v-if="loading"
                        :loading="loading"
                        variant="text"
                        style="width: 80%"
                      />
                      <input
                        v-if="
                          !loading && !info.Attachment && !assessment.isDisabled
                        "
                        type="file"
                        multiple
                        value=""
                        class="bg-gray-200 p-2"
                        v-on:change="getFile"
                        :disabled="!assessment.isDisabled"
                      />

                      <el-button
                        v-if="
                          !loading && info.Attachment && !assessment.isDisabled
                        "
                        type="plain"
                        @click="showAttachedDocs = true"
                        >View Attached Files</el-button
                      >

                      <input
                        v-if="
                          !loading &&
                          !info.myReviews[0].Attachment &&
                          assessment.isDisabled
                        "
                        type="file"
                        multiple
                        :value="info.myReviews[0].Attachment"
                        class="bg-gray-200 p-2"
                        :disabled="!assessment.isDisabled"
                      />

                      <el-button
                        v-if="
                          !loading &&
                          info.myReviews[0].Attachment &&
                          assessment.isDisabled
                        "
                        type="plain"
                        @click="showAttachedDocs = true"
                        >View Attached Files</el-button
                      >
                    </div>
                  </div>

                  <div class="flex w-full items-center p-2">
                    <div class="flex w-full items-center p-2">
                      <div class="flex flex-col w-full">
                        <h1 class="font-bold text-lg">Rating</h1>

                        <el-skeleton
                          :rows="1"
                          animated
                          v-if="loading"
                          :loading="loading"
                          variant="button"
                          style="width: 80%"
                        />
                        <select
                            v-if="!loading && !assessment.isDisabled"
                            class="bg-gray-200"
                            :value="info.Rating"
                            required
                            :disabled="assessment.isDisabled"
                        >
                          <option value="5">Exceeding Expectations</option>
                          <option value="4">Meeting Expectations</option>
                          <option value="3">
                            Meeting Expectations with Reservations
                          </option>
                          <option value="2">Approaching Expectations</option>
                          <option value="1">Below Expectations</option>
                        </select>

                        <select
                            v-if="!loading && assessment.isDisabled"
                            class="bg-gray-200"
                            :value="infoByReviewId[review.ObjectiveId].myReview[0].Rating"
                            required
                            :disabled="!assessment.isDisabled"
                        >
                          <option value="5">Exceeding Expectations</option>
                          <option value="4">Meeting Expectations</option>
                          <option value="3">
                            Meeting Expectations with Reservations
                          </option>
                          <option value="2">Approaching Expectations</option>
                          <option value="1">Below Expectations</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </section>
                <div class="p-4">
                  <label>Comment </label>
                  <el-skeleton
                    :rows="3"
                    animated
                    v-if="loading"
                    :loading="loading"
                    variant="text"
                    style="width: 90%"
                  />
                  <textarea
                      v-if="!loading && infoByReviewId[review.ObjectiveId].myReview && !assessment.isDisabled"
                      name="myreview-comment"
                      id="myreview-comment"
                      cols="5"
                      rows="5"
                      class="w-full p-2 border-1.5 rounded bg-gray-200"
                      style="width: 100% !important"
                      :value="info.Comment"

                      :disabled="!assessment.isDisabled"
                  ></textarea>
                  <textarea
                      v-if="!loading && infoByReviewId[review.ObjectiveId] && assessment.isDisabled"
                      name="myreview-comment"
                      id="myreview-comment"
                      cols="5"
                      rows="5"
                      class="w-full p-2 border-1.5 rounded bg-gray-200"
                      style="width: 100% !important"
                      v-model="infoByReviewId[review.ObjectiveId].myReview[0].Comment"
                      :disabled="assessment.isDisabled"
                  ></textarea>
                </div>
              </main>
            </section>
            <section class="flex gap-2 justify-end my-2">
              <el-button
                type="info"
                class="rounded-full"
                @click="handleSubmit('draft')"
                >Save as Draft</el-button
              >
              <el-button type="warning" @click="handleSubmit('final')"
                >Submit</el-button
              >
            </section>
          </main>
        </el-collapse-item>
      </el-collapse>
      <div
        v-if="!loading && reviews.length == 0"
        class="flex flex-col justify-center items-center h-full mt-5"
      >
        <el-empty :image-size="70" description="No Data"></el-empty>
      </div>
    </div>
    <PerfReviewAttachments
      :showAttachedDocs="showAttachedDocs"
      :info="info"
      @close="showAttachedDocs = false"
    ></PerfReviewAttachments>
  </div>
</template>

<script>
import axios from 'axios';
import OneGoal from './oneGoal.vue';
import { mapGetters } from 'vuex';
import Loader from '@/components/loader/loader.vue';
import PerfReviewAttachments from '@/components/employees/modals/perfReviewAttachments.vue';

export default {
  name: 'MyReviewsGoals',
  components: { OneGoal, Loader, PerfReviewAttachments },
  data() {
    return {
      showGoal: false,
      loading: false,
      showAttachedDocs: false,
      activeItem: '',
      completed:[],
      drafts:[],
      pending:[],
      infoByReviewId: {},
      info: {
        ObjectiveReviewId: '',
        ObjectiveId: '',
        ObjectiveStatus: 'Draft',
        ReviewType: 'Mine',
        Rating: '',
        AchievedTarget: '',
        Attachment: '',
        Comment: '',
        myReviews: [
          {
            AchievedTarget: '',
            Attachment: '',
            Comment: '',
            Created: '',
            CreatedBy: '',
            Id: '',
            ModifiedBy: '',
            ObjectiveStatus: '',
            Rating: null,
            ReviewType: '',
            Updated: '',
          },
        ],
      },
      assessments: [
        { name: 'My Assessment', isDisabled: true },
        { name: 'Manager Assessment', isDisabled: false },
      ],
      columns: [
        {
          field: 'Name',
          key: 'a',
          title: 'Objective Name',
          renderBodyCell: ({ row }) => {
            return (
              <p
                on-click={() => (this.showGoal = true)}
                class='text-blue-500 cursor-pointer'
              >
                {row.Name}
              </p>
            );
          },
        },
        { field: 'Category', key: 'b', title: 'Category' },
        /*  { field: "DueDate", key: "c", title: "Due Date" }, */
        {
          field: 'MyReview',
          key: 'x',
          title: 'My Review',
        },
        {
          field: 'Attachment',
          key: 'd',
          title: 'Attachment',
          renderBodyCell: () => {
            return <p class='cursor-pointer font-bold'>&#128206;</p>;
          },
        },
        {
          field: 'Feedback',
          key: 'f',
          title: 'Feedback',
          renderBodyCell: () => {
            return (
              <img
                class='h-6 object-contain cursor-pointer px-5'
                src='@/assets/icons/cross-white.png'
              />
            );
          },
        },
      ],
      reviews: [],
    };
  },
  created() {
    this.fetchData();
  },
  computed: {
    ...mapGetters(['getOrganization', 'getToken']),
    reviewGroups() {
      return {
        pending: this.pending,
        drafts: this.drafts,
        completed: this.completed,
      };
    },
  },
  methods: {
    getFile({ target }) {
      const file = target.files[0];
      this.info.Attachment = file;
      const blob = new Blob([file], { type: '*' });
      this.preview = URL.createObjectURL(blob);
    },
    handleItemClick(reviewId) {
      let activeReview = this.reviews.find(
        (review) => review.ObjectiveId === reviewId
      ).Reviews;
      let myReviews = activeReview.filter(
        (review) => review.ReviewType === 'Mine'
      );
      let managerReviews = activeReview.filter(
        (review) => review.ReviewType === 'Manager'
      );

      if (!myReviews.length) {
        myReviews = {
          AchievedTarget: '',
          Attachment: '',
          Comment: '',
          Created: '',
          CreatedBy: '',
          Id: '',
          ModifiedBy: '',
          ObjectiveStatus: '',
          Rating: null,
          ReviewType: '',
          Updated: '',
        };
      }

      if (!managerReviews.length) {
        managerReviews = {
          AchievedTarget: '',
          Attachment: '',
          Comment: '',
          Created: '',
          CreatedBy: '',
          Id: '',
          ModifiedBy: '',
          ObjectiveStatus: '',
          Rating: null,
          ReviewType: '',
          Updated: '',
        };
      }
      this.$set(this.infoByReviewId, reviewId, {
        reviewId,
        managerReview: managerReviews,
        myReview: myReviews,
      });
      this.info = {
        reviewId,
        ...this.info,
        ...managerReviews[0],
        myReviews,
      };
      this.loading = false;
    },

    fetchData() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
        params:{
          type:'manager'
        }
      };

      const apiUrl = `${this.getOrganization}/performance/objective/mine/${this.$ApiVersion}/request`;

      axios
        .get(apiUrl, options)
        .then((response) => {
          if (response.data.StatusCode == 200) {
            this.reviews = response.data.Data;

            this.completed = this.reviews.filter(item=>item.Reviews.some(review=>review.ReviewType==="Manager" && review.ObjectiveStatus==="Submitted"))
            this.drafts = this.reviews.filter(item=>item.Reviews.some(review=>review.ReviewType==="Manager" && review.ObjectiveStatus==="Draft"))
            this.pending = this.reviews.filter(item =>
                item.Reviews.every(review =>
                    review.ReviewType !== "Manager" ||
                    (review.ObjectiveStatus !== "Submitted" && review.ObjectiveStatus !== "Draft")
                )
            );
            this.loading = false;
          } else {
            this.$notify.error({
              title: 'Failure',
              message: 'Error occured while fetching data.',
            });
          }
        })
        .catch((error) => {
          this.$notify.error({
            title: 'Failure',
            message: 'Error occured while fetching records.',
          });
          console.error('Error fetching data:', error);
        });
    },
    getStatusImagePath(status) {
      return require(`@/assets/icons/status-${status}.png`);
    },
    refresh() {
      this.fetchData();
    },

    async postData(data /*, isDraft*/) {
      const action = 'add'; //: "edit";
      const verb = 'post'; //: "put";
      let response;
      try {
        const apiUrl = `${this.getOrganization}/performance/objective/review/${this.$ApiVersion}/${action}`;

        const options = {
          headers: {
            Authorization: `Bearer ${this.getToken}`,
            'Content-Type': 'multipart/form-data',
          },
        };

        response = await axios[verb](apiUrl, data, options);
        // console.log(response);
        if (response.data.StatusCode === 200) {
          this.$notify({
            title: 'Success',
            message: response.data.StatusMessage,
            type: 'success',
          });
          this.fetchData();
        } else {
          throw new Error(`Unexpected status code: ${response.status}`);
        }
      } catch (error) {
        this.loading = false;
        this.$notify.error({
          title: 'Failure',
          message: response.data.StatusMessage,
        });
        console.error('Error in API call:', error);
      }
    },
    handleSubmit(status) {
      const formData = new FormData();
      formData.append('ObjectiveId', this.activeItem);
      formData.append('ReviewType', 'Manager');
      formData.append('Rating', parseInt(this.info.Rating, 10));
      formData.append('AchievedTarget', this.info.AchievedTarget);
      formData.append('Attachment', this.info.Attachment);
      formData.append('Comment', this.info.Comment);
      if (status === 'final') {
        formData.append('ObjectiveStatus', 'Submitted');

        this.postData(formData, true);
      } else {
        formData.append('ObjectiveStatus', 'Draft');

        this.postData(formData, false);
      }
    },
  },
};
</script>
<style>
.el-collapse-item__header {
  background-color: white !important;
  padding: 0.1rem 1rem;
  border-radius: 0.5rem;
}
</style>
